<template>
  <div class="modal-body">
    <div class="registration-errors" v-show="errorMessage">
      <div class="alert alert-danger">{{errorMessage}}</div>
    </div>

    <div class="p-b-30"></div>

    <div class="payment-info m-t-100">
      <div
        v-if="basket?.order?.summary?.total_price"
        class="text-center free-payment-message"
        v-html="settings.freePaymentMessage"
      ></div>

      <div
        v-else
        class="text-center success-payment-message"
        v-html="settings.successPaymentMessage"
      ></div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters("basketStore", [
      "basket",
      "settings"
    ])
  }
}
</script>

<style lang="scss" scoped>
</style>
